import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { LOCALES } from 'src/utils/constants';

export const routing = defineRouting({
    locales: LOCALES,
    defaultLocale: 'en',
});

export type Locale = (typeof routing.locales)[number];

export const { Link, redirect, usePathname, useRouter, getPathname } =
    createNavigation(routing);
